module.exports = __webpack_public_path__ + "static/media/leftCloud.8a3f8f56.png";